module.exports = __webpack_public_path__ + "img/tb1.d66b5c35.png";